// @ts-nocheck
export const localeCodes =  [
  "cs",
  "sk",
  "en"
]
export const localeLoaders = {
  cs: [
    {
      key: "locale_cs_45CZ_46json5_21a4ad2f",
      load: () => import("#nuxt-i18n/21a4ad2f" /* webpackChunkName: "locale_cs_45CZ_46json5_21a4ad2f" */),
      cache: true
    },
    {
      key: "locale_cs_45CZ_46json5_f6686371",
      load: () => import("#nuxt-i18n/f6686371" /* webpackChunkName: "locale_cs_45CZ_46json5_f6686371" */),
      cache: true
    },
    {
      key: "locale_cs_45CZ_46json5_997639ce",
      load: () => import("#nuxt-i18n/997639ce" /* webpackChunkName: "locale_cs_45CZ_46json5_997639ce" */),
      cache: true
    }
  ],
  sk: [
    {
      key: "locale_sk_45SK_46json5_859e2066",
      load: () => import("#nuxt-i18n/859e2066" /* webpackChunkName: "locale_sk_45SK_46json5_859e2066" */),
      cache: true
    },
    {
      key: "locale_sk_45SK_46json5_68907b4c",
      load: () => import("#nuxt-i18n/68907b4c" /* webpackChunkName: "locale_sk_45SK_46json5_68907b4c" */),
      cache: true
    },
    {
      key: "locale_sk_45SK_46json5_010739e7",
      load: () => import("#nuxt-i18n/010739e7" /* webpackChunkName: "locale_sk_45SK_46json5_010739e7" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_45US_46json5_59d542a9",
      load: () => import("#nuxt-i18n/59d542a9" /* webpackChunkName: "locale_en_45US_46json5_59d542a9" */),
      cache: true
    },
    {
      key: "locale_en_45US_46json5_55817efa",
      load: () => import("#nuxt-i18n/55817efa" /* webpackChunkName: "locale_en_45US_46json5_55817efa" */),
      cache: true
    },
    {
      key: "locale_en_45US_46json5_5f5f3abc",
      load: () => import("#nuxt-i18n/5f5f3abc" /* webpackChunkName: "locale_en_45US_46json5_5f5f3abc" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = [
  () => import("#nuxt-i18n/765f8d89" /* webpackChunkName: "config_i18n_46config_46ts_765f8d89" */)
]
export const normalizedLocales = [
  {
    code: "cs",
    language: "cs-CZ",
    name: "Česky",
    flag: "/images/flags/flag-cz.webp",
    flagAlt: "Česká vlajka",
    domainDefault: true,
    domain: "https://demo.simploshop.cz"
  },
  {
    code: "sk",
    language: "sk-SK",
    name: "Slovensky",
    flag: "/images/flags/flag-sk.webp",
    flagAlt: "Slovenská vlajka",
    domainDefault: true,
    domain: "https://demo.simploshop.sk"
  },
  {
    code: "en",
    language: "en-US",
    name: "English",
    flag: "/images/flags/flag-uk.webp",
    flagAlt: "",
    domainDefault: true,
    domain: "https://demo.simploshop.com"
  }
]
/** client **/

/** client-end **/